/**
 * When the contractor site is embedded in the dashboard (?preview=…), block in-frame
 * navigations to other origins (e.g. main app / marketing URLs) while allowing same-site,
 * hash, tel, and mailto links. _blank is allowed (opens outside the iframe).
 */
export function shouldAllowPreviewAnchorNavigation(
  anchor: HTMLAnchorElement,
  pageOrigin: string,
): boolean {
  const rawTarget = anchor.getAttribute("target");
  const target = (rawTarget ?? "_self").trim().toLowerCase();
  if (target === "_top" || target === "_parent") {
    return false;
  }
  if (target === "_blank") {
    return true;
  }

  let url: URL;
  try {
    url = new URL(anchor.href, pageOrigin);
  } catch {
    return false;
  }

  const scheme = url.protocol.toLowerCase();
  if (scheme === "tel:" || scheme === "mailto:" || scheme === "sms:") {
    return true;
  }

  return url.origin === pageOrigin;
}

export function isDashboardPreviewEmbed(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return new URLSearchParams(window.location.search).has("preview");
}
